import { gql } from '@apollo/client'

export const GET_ADDITIONAL_COMPONENTS_BY_CODES = gql`
  query GetAdditionalComponentsByCodes($codes: [String!]!) {
    findManyAdditionalComponent(where: { code: { in: $codes } }) {
      id
      code
      component_sku
      image {
        src_thumbnail
        src_md
      }
      additional_component_profiles {
        id
        name
        language
        material_name
        description
      }
    }
  }
`

export const GET_FABRIC_PRICES = gql`
  query FindUniqueAdditionalComponent(
    $where: AdditionalComponentWhereUniqueInput!
    $advancedProductId: Int
    $priceListId: Int
  ) {
    findUniqueAdditionalComponent(where: $where) {
      id
      code
      additional_component_to_advanced_product(
        where: { advancedProductId: { equals: $advancedProductId } }
      ) {
        enabled
        id
        advancedProductId
        extra_prices(where: { price_listId: { equals: $priceListId } }) {
          id
          price
          price_listId
        }
        price_fabric_category(
          where: { price_listId: { equals: $priceListId } }
        ) {
          id
          price
          price_listId
          fabrice_price_category {
            group_number
            id
          }
        }
      }
    }
  }
`

export const GET_ADDITIONAL_COMPONENT = gql`
  query FindUniqueAdditionalComponent($id: Int!, $advancedProductId: Int!) {
    findUniqueAdditionalComponent(where: { id: $id }) {
      id
      additionalComponentGroupId
      code
      component_sku
      conditions
      dimensions {
        width
        height
        length
        radius
        weight
        seat_height
        seat_width
        seat_depth
        armrest_height
        armrest_length
        armrest_width
        backrest_width
        fabric_usage
        corner_part_length
        corner_radius
        mattress_width
        mattress_length
        mattress_height
        headboard_height
        headboard_width
        table_extended_lengh
        shade_height
        shade_radius

        lying_part_height
        leg_height
        mattress_overlay_height
        bedbox_height
        bedbox_width
        bedbox_length
        frame_thickness
        table_top_thickness
        table_leg_width
        seat_sections
        backrest_sections
        extension_type
        backrest_type
        covered_side
      }
      image {
        src_md
        src
      }
      package_dimensions {
        id
        name
        volume
      }
      additional_component_profiles {
        id
        language
        material_name
        name
        description
      }
      additional_component_to_advanced_product(
        where: { advancedProductId: { equals: $advancedProductId } }
      ) {
        id
        advancedProductId
        extra_price
        extra_prices {
          id
          price
          price_listId
        }
        conditions
        isDefault
        metadata
        enabled
      }
      additional_component_group {
        enable_custom_dimensions_for_components
        enabled_dimensions_in_group
      }
    }
  }
`

export const GET_ADDITIONAL_COMPONENTS_BY_GROUP = gql`
  query GetAdditionalComponentsByGroup(
    $groupId: Int!
    $advancedProductId: Int!
  ) {
    findManyAdditionalComponent(
      where: {
        additionalComponentGroupId: { equals: $groupId }
        NOT: {
          additional_component_to_advanced_product: {
            some: { advancedProductId: { equals: $advancedProductId } }
          }
        }
      }
    ) {
      id
      code
      component_sku
      additionalComponentGroupId
      image {
        src_thumbnail
        src_md
      }
      additional_component_profiles {
        id
        name
        language
        material_name
        description
      }
    }
  }
`

export const ADD_COMPONENT_TO_PRODUCT = gql`
  mutation AddComponentToProduct(
    $advancedProductId: Int!
    $additionalComponentId: Int!
    $enabled: Boolean = true
  ) {
    createOneAdditionalComponentToAdvancedProduct(
      data: {
        enabled: $enabled
        advanced_product: { connect: { id: $advancedProductId } }
        additional_component: { connect: { id: $additionalComponentId } }
      }
    ) {
      id
      enabled
      additional_component {
        id
        code
        component_sku
        additional_component_profiles {
          id
          name
          language
        }
      }
    }
  }
`
